module.exports = __webpack_public_path__ + "static/media/yay.e692b002.svg";